export const STYLE = {
  PAGES: {
    INDEX: {
      APP_LAYOUT: {
        LAYOUT:
          'bg-bw02 pl-[10rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col',
        TITLE: 'font-metricMedium text-xl',
      },
      MAIN_CONTENT: 'relative flex flex-col p-[40px] bg-bw00 rounded-lg w-[456px] min-h-[548px]',
      MAIN_CONTENT_NEW: 'relative flex flex-col pt-[40px] pl-[40px] pr-[40px] pb-[40px] bg-bw00 rounded-lg w-[456px]',
      SUB_CONTENT: 'flex flex-col relative p-[40px] bg-bw00 rounded-lg w-[360px] max-h-[65.6vh] min-h-[548px]',
      SUB_CONTENT_NEW: 'flex flex-col relative bg-bw00 rounded-lg p-[40px] w-[360px] max-h-[65.6vh]',
    },
    GET_STARTED: {
      HEADING_IMAGE: 'w-[80px] mb-[24px]',
      HEADING: 'font-metricMedium text-[25px] text-bw08 mb-[16px]',
      CONTENT: 'text-sm font-metric text-bw07 mb-[24px] ',
      SUPPORTED_BANKS_CTA: {
        CHILD: {
          CONTAINER: 'flex align-middle mb-[36px]',
          HEADING: 'font-metric text-[14px] text-bw07 mr-[15px]',
          ICON: 'w-[8px] text-bw06',
        },
      },
      PLAID_CTA: 'w-[240px] text-sm text-bw00 bg-action03 hover:bg-action04 h-12 rounded font-metricBold',
    },
    POST_LINKED: {
      HEADING: 'font-metricMedium text-[25px] text-bw08 mb-[16px]',
      CONTENT: 'text-sm font-metric text-bw07 mb-[40px]',
      LIST_HEADING_CTA_WRAPPER: 'flex justify-between w-full mb-[16px]',
      LIST_HEADING: 'font-metricMedium text-[16px] text-bw07',
      LIST_CTA: 'font-metric text-[13px] text-bw05',
      LIST_WRAPPER:
        'flex flex-col w-full rounded-md border-solid border-[1px] border-bw03 mb-[16px] max-h-[384px] overflow-auto animate-fadeIn',
      LINK_ITEM: {
        WRAPPER_BASE: 'flex px-4 py-4 cursor-pointer',
        WRAPPER_SELECTED: 'bg-action03 bg-opacity-20',
        WRAPPER_BORDER_BOTTOM: 'border-b-[1px] border-b-bw03',
        CONTENT_WRAPPER: 'flex flex-col',
        REMOVE_ICON: 'w-[20px] mr-4',
        HEADING: 'font-metricMedium text-base text-action03 mb-1.5',
        CONTENT: 'text-xs font-metric text-bw07',
      },
      PLAID_CTA: 'text-sm text-action03 font-metricMedium self-baseline',
      MONEY_TRANSFER: {
        HEAD: {
          WRAPPER: 'pb-[16px] mb-[16px] border-b-[1px] border-b-bw03 flex flex-col',
          SECTION_HEAD: 'mb-[8px] font-metricSemibold text-bw08 text-base',
          SECTION_INFO: 'font-metric text-bw07 text-base',
        },
        BODY: {
          WRAPPER: 'w-full flex flex-col items-center',
          MAIN_HEADING: 'font-metricSemibold text-[18px] text-bw08 mb-[21px]',
          BALANCE_WRAPPER: 'flex items-center',
          BALANCE_AMOUNT: 'mr-[4px] font-metricMedium text-action03 text-22',
          BALANCE_CONTENT: 'font-metric text-bw07 text-base',
          LINK_ACCOUNT_INFO: 'font-metric text-bw07 text-base mb-[24px] text-center',
          INPUT:
            'placeholder:pr-[15px] placeholder:text-base caret-action03 font-metricMedium text-bw08 text-[24px] h-[64px] w-full rounded-md text-center outline-none border-action03 border-[1px]',
          INPUT_DISABLED:
            'placeholder:pr-[15px] placeholder:text-base caret-red02 font-metricMedium text-bw08 text-[24px] h-[64px] w-full rounded-md text-center outline-none border-red02 border-[1px] mb-[6px]',
          ERROR: 'font-metric text-red02 text-center text-xxs',
        },
        FOOTER: {
          WRAPPER: 'flex flex-col mt-auto',
          CTA: 'w-full mb-[12px] text-sm text-bw00 bg-action03 h-12 rounded font-metricBold',
          DISABLED_CTA:
            'font-metricSemibold mb-[12px] text-bw00 text-opacity-50 bg-bw05 py-[13px] px-[34px] text-sm rounded-[4px]',
          CONTENT: 'font-metric text-sm text-bw07 text-center',
        },
        CONFIRMATION_MODAL_CONTENT: {
          WRAPPER: 'w-[456px] px-[40px] py-[16px] bg-bw00 rounded-[8px]',
          MAIN_HEADING: 'font-metricRMedium text-bw08 text-[22px] mb-[16px] w-[70%]',
          TRANSFER_DETAILS: {
            WRAPPER: 'w-full mb-[30px]',
            AMOUNT: {
              WRAPPER:
                'w-full h-[56px] p-[16px] flex items-center justify-between rounded-[8px] border-bw03 border-solid border-[1px] mb-[14px] box-border',
              HEADING_1: 'font-metricR text-md text-bw06 leading-6',
              HEADING_2: 'font-metricRSemibold text-xl text-action03 leading-6',
            },
            FROM_TO: {
              WRAPPER:
                'w-full flex justify-between flex-wrap rounded-[8px] border-bw03 border-solid border-[1px] mb-[14px]',
            },
            FROM: {
              WRAPPER: 'w-full flex justify-between p-[16px] border-x-[1px] border-t-[1px] border-bw03 rounded-t-lg',
              INNER_WRAPPER: 'flex flex-col text-end',
              HEADING_1: 'font-metricR text-md text-bw06',
              HEADING_2: 'mb-[5px] font-metricRMedium text-bw08 text-md',
              HEADING_3: 'font-metricR text-bw07 text-md',
            },
            SPLITTER: 'w-full h-[0.5px] bg-bw03',
            TO: {
              WRAPPER: 'w-full flex justify-between p-[16px] border-x-[1px] border-b-[1px] border-bw03 rounded-b-lg',
              WRAPPER_SEND_MONEY: 'w-full flex justify-between',
              INNER_WRAPPER: 'flex flex-col text-end',
              HEADING_1: 'font-metricR text-md text-bw06',
              HEADING_2: 'mb-[5px] font-metricRMedium text-bw08 text-md',
              HEADING_3: 'font-metricR text-bw07 text-md',
            },
            ESTIMATE: {
              WRAPPER: 'w-full flex flex-col rounded-[8px] border-bw03 border-solid border-[1px] p-[16px] mt-[14px]',
              HEADING_1: 'font-metricR text-md text-bw07',
              HEADING_2: 'font-metricRMedium text-md text-bw08',
            },
          },
          TRANSFER_ACTIONS: {
            WRAPPER: 'w-fit ml-auto flex items-center',
            CANCEL: 'font-metricMedium text-bw06 text-sm mr-[30px]',
            CONFIRM_ENABLE:
              'font-metricRSemibold text-bw00 bg-action03 py-[13px] px-[34px] text-base rounded-[4px] h-[50px] max-h-[50px] w-[128px]',
            CONFIRM_DISABLE:
              'font-metricRSemibold text-bw00 text-opacity-50 bg-action02 py-[13px] px-[34px] text-base rounded-[4px]',
          },
          TRANSFER_DISCLAIMER: {
            WRAPPER: 'flex items-start mb-[55px]',
            CONTENT: 'font-sourceSansPro text-bw06 text-sm',
          },
        },
      },
    },
    FLOW_SUCCEED: {
      WRAPPER: 'flex flex-col items-center pa-[40px]',
      ICON: 'w-[70px] mb-[27px]',
      HEADING: 'font-metricMedium text-bw08 text-[25px] leading-[168%] w-[85%] mb-[16px]',
      HEADING_NEW: 'font-metricMedium text-bw08 text-[25px] leading-[120%] w-[85%] mb-[26px]',
      SUB_CONTENT_1: 'font-metric text-base text-bw07 pb-[20px] border-b-bw03 border-b mb-[20px]',
      SPAN: 'font-metricMedium',
      SUB_CONTENT_2: 'font-metric text-bw07 text-sm mb-[24px] mt-[24px]',
      CTA: 'w-[240px] text-sm text-bw00 bg-action03 h-12 rounded font-metricRSemibold',
      CTA_NEW: 'w-full mt-[11px] text-sm text-bw00 bg-action03 h-[50px] rounded font-metricRSemibold',
      NEW_ADD_MONEY_SUB_CONTENT: 'font-metricR text-md text-bw07 mb-[16px]',
    },
  },
};

export const TEXT = {
  PAGES: {
    INDEX: {
      LAYOUT: {
        HEADER: 'ADD_MONEY_LAYOUT_HEADER',
        HEADER_SEND_MONEY: 'SEND_MONEY_LAYOUT_HEADER',
      },
    },
    GET_STARTED: {
      CONTENT: 'ADD_MONEY_GET_STARTED_CONTENT',
      CONTENT_SEND_MONEY: 'SEND_MONEY_GET_STARTED_CONTENT',
      HEADING: 'ADD_MONEY_GET_STARTED_HEADING',
      HEADING_SEND_MONEY: 'SEND_MONEY_GET_STARTED_HEADING',
      SUPPORTED_BANKS_CTA: {
        CHILD: {
          HEADING: 'ADD_MONEY_GET_STARTED_CTA_SUPPORTED_BANKS',
        },
      },
      PLAID_CTA: 'GET_STARTED_PLAID_CTA',
    },
    POST_LINKED: {
      HEADING: 'ADD_MONEY_GET_POST_LINK_HEADING',
      HEADING_SEND: 'SEND_MONEY_GET_POST_LINK_HEADING',
      CONTENT: 'ADD_MONEY_GET_POST_LINK_CONTENT',
      CONTENT_SEND: 'SEND_MONEY_GET_POST_LINK_CONTENT',
      SUB_HEADER: 'ADD_MONEY_GET_POST_LINK_SUB_HEADER',
      EDIT_ACCOUNTS_LIST_CTA_MODE_A: 'ADD_MONEY_GET_POST_LINK_EDIT_LIST_MODE_A',
      EDIT_ACCOUNTS_LIST_CTA_MODE_B: 'ADD_MONEY_GET_POST_LINK_EDIT_LIST_MODE_B',
      PLAID_CTA: 'ADD_MONEY_POST_LINK_PLAID_CTA',
      MONEY_TRANSFER: {
        HEAD: {
          HEADING: 'ADD_MONEY_TRANSFER_MONEY_HEAD_HEADING',
        },
        BODY: {
          HEADING: 'ADD_MONEY_TRANSFER_MONEY_BODY_HEADING',
          BALANCE_CONTENT: 'ADD_MONEY_TRANSFER_MONEY_BODY_BALANCE_CONTENT',
          BALANCE_LINE_1: 'ADD_MONEY_TRANSFER_BODY_BALANCE_LINE_1',
          BALANCE_LINE_2: 'ADD_MONEY_TRANSFER_BODY_BALANCE_LINE_2',
          MAX_TRANSFER: 'ADD_MONEY_FLOW_TRANSFER_AMOUNT_ERROR',
          MAX_TRANSFER_CHECKING_ACCOUNT: 'ADD_MONEY_FLOW_TRANSFER_AMOUNT_CHECKING_ERROR',
        },
        FOOTER: {
          CTA_TITLE: 'ADD_MONEY_TRANSFER_MONEY_FOOTER_CTA_TITLE',
          CONTENT: 'ADD_MONEY_TRANSFER_MONEY_FOOTER_CONTENT',
        },
        USER_MESSAGE: {
          MAIN_HEADING: 'ADD_MONEY_TRANSFER_MONEY_UM_MAIN_HEADING',
          DISCLAIMER: 'ADD_MONEY_TRANSFER_MONEY_UM_DISCLAIMER',
          DISCLAIMER_REPLACE_PARAM: 'INSTITUTION_NAME',
          AMOUNT: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_1',
          FROM: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_2',
          TO: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_3',
          ESTIMATE: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_4',
          CHECKING_ACCOUNT: 'ADD_MONEY_TRANSFER_MONEY_UM_DETAILS_ITEM_5',
          CTA_CANCEL: 'ADD_MONEY_TRANSFER_MONEY_UM_ACTION_CANCEL',
          CTA_CONFIRM: 'ADD_MONEY_TRANSFER_MONEY_UM_ACTION_CONFIRM',
          ADD_MONEY_TO_SUB_HEADER: 'ADD_MONEY_TRANSFER_MONEY_UM_LILI_ACCOUNT',
        },
      },
    },
    FLOW_SUCCEED: {
      HEADING: 'ADD_MONEY_FLOW_SUCCEED_HEADING',
      HEADING_SEND: 'SEND_MONEY_FLOW_SUCCEED_HEADING',
      SUB_CONTENT_LINE_1: 'ADD_MONEY_FLOW_SUB_CONTENT_1_LINE_1',
      SUB_CONTENT_LINE_2: 'ADD_MONEY_FLOW_SUB_CONTENT_1_LINE_2',
      SUB_CONTENT_LINE_3: 'ADD_MONEY_FLOW_SUB_CONTENT_1_LINE_3',
      SUB_CONTENT_LINE_4: 'ADD_MONEY_FLOW_SUB_CONTENT_1_LINE_4',
      SUB_CONTENT_LINE_5: 'ADD_MONEY_FLOW_SUB_CONTENT_2_LINE_1',
      CTA: 'ADD_MONEY_FLOW_SUCCEED_CTA',
      CTA_NEW: 'ADD_MONEY_FLOW_SUCCEED_CTA_NEW',
      NEW_ADD_MONEY_SUB_CONTENT: 'NEW_ADD_MONEY_SUB_CONTENT',
      AMOUNT: 'NEW_TRANSFER_DETAILS_AMOUNT',
      FROM: 'NEW_TRANSFER_DETAILS_FROM',
      ACCOUNT_NUMBER: 'NEW_TRANSFER_DETAILS_ACCOUNT',
      ROUTING_NUMBER: 'NEW_TRANSFER_DETAILS_ROUTING',
      SEND_TO: 'NEW_TRANSFER_DETAILS_SEND_TO',
      ESTIMATED_ARRIVAL: 'NEW_TRANSFER_DETAILS_ARRIVAL',
      PROCESSING_DATE: 'NEW_TRANSFER_DETAILS_PROCESSING_DATE',
      MY_LILI_ACCOUNT: 'NEW_TRANSFER_DETAILS_MY_LILI_ACCOUNT',
    },
  },
} as const;

export const IDS = {
  PAGES: {
    GET_STARTED: {
      SUPPORTED_BANKS_CTA: 'supported-banks-cta',
      DEMI_PLAID_CTA: 'demi-plaid-cta',
    },
  },
} as const;

export const LINKS = {
  SUPPORTED_BANKS:
    'https://support.lili.co/hc/en-us/articles/360042077912-How-do-I-link-an-external-bank-account-to-my-Lili-account-',
} as const;

export const INVALID_TRANSFER_VALUES = {
  ZERO: '0',
}as const;
